module.exports = __webpack_public_path__ + "img/58_20.eab69b2c.png";